export default __webpack_public_path__ + "static/media/Beard_11_C1.738e292a.svg";